import Form from '@/libs/form';

const fields = ['name', 'styles', 'providers', 'messages', 'redirect_rules', 'advertisements', 'surveys', 'agreements'];

const rules = {
   name: 'required',
};

export default Form.create(fields).validate(rules);
